/* This file is autogenerated, see readme.md for instructions */
import BarChartSvgIcon from '@bloomreach/banana-theme/icons/bar-chart.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const BarChartIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <BarChartSvgIcon />
    </Icon>
  );
});

BarChartIcon.displayName = 'BarChartIcon';

export default BarChartIcon;
